<template>
    <div class="pdf-container-outer">
        <div v-if="loadingProgress || isLoading" class="loadingContainer">
            <div id="progress" class="progressBar">
                <div id="progress-value">
                    {{ progress }} %
                </div>
            </div>
            <p style="margin-top: 150px;">Yükleniyor...</p>
        </div>

        <div class="pdf-controller">
            <div class="pdf-controller-inner">
                <template v-if="isLoading">
                    Yükleniyor...
                </template>

                <template v-else>
                    <span v-if="showAllPages">
                        {{ pageCount }} sayfa
                    </span>

                    <span v-else>
                        <button class="btn btn-sm navigationButtons" type="button" :disabled="page <= 1" @click="page--"><svg
                                xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                                fill="none">
                                <path d="M15 6L9 12L15 18" stroke="#fff" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg></button>

                        {{ page }} / {{ pageCount }}

                        <button class="btn btn-sm navigationButtons" :disabled="page >= pageCount" type="button" @click="page++"><svg
                                xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                                fill="none">
                                <path d="M9 6L15 12L9 18" stroke="#fff" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg></button>

                    </span>

                    <label class="right">
                        <input v-model="showAllPages" type="checkbox">
                        Tüm sayfaları göster
                    </label>
                    <div v-if="!showAllPages">
                        <button class="btn btn-sm rotationButtons" type="button" @click="rotate(0)"><svg
                                xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24px" height="24px"
                                viewBox="0 0 1920 1920">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M1251.45 447.883 1120 316.432h160c176.73 0 320 143.269 320 320h106.67c0-235.641-191.03-426.666-426.67-426.666h-159.97l134.34-134.341L1178.94 0 915.833 263.111l260.197 260.196 75.42-75.424Zm28.55 405.45C1280 735.513 1184.49 640 1066.67 640H213.333C95.513 640 0 735.513 0 853.333v853.337C0 1824.49 95.513 1920 213.333 1920h853.337c117.82 0 213.33-95.51 213.33-213.33V853.333Zm-213.33-106.666H213.333c-58.91 0-106.666 47.756-106.666 106.666v853.337c0 58.91 47.756 106.66 106.666 106.66h853.337c58.91 0 106.66-47.75 106.66-106.66V853.333c0-58.91-47.75-106.666-106.66-106.666Z" />
                            </svg></button>
                        <button class="btn btn-sm rotationButtons" type="button" @click="rotate(1)"><svg
                                xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24px" height="24px"
                                viewBox="0 0 1920 1920">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M639.999 209.777h116.019L621.665 75.425 697.09 0l263.111 263.111-260.196 260.196-75.425-75.424 131.439-131.439h-116.02c-176.731 0-320 143.269-320 320H213.332c0-235.642 191.025-426.667 426.667-426.667Zm0 643.556c0-117.82 95.512-213.333 213.333-213.333h853.338c117.82 0 213.33 95.513 213.33 213.333v853.337c0 117.82-95.51 213.33-213.33 213.33H853.332c-117.821 0-213.333-95.51-213.333-213.33V853.333Zm213.333-106.666h853.338c58.91 0 106.66 47.756 106.66 106.666v853.337c0 58.91-47.75 106.66-106.66 106.66H853.332c-58.91 0-106.667-47.75-106.667-106.66V853.333c0-58.91 47.757-106.666 106.667-106.666Z" />
                            </svg>
                        </button>
                        <button class="btn btn-sm rotationButtons" type="button" @click="zoomOut()">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="File" transform="translate(-864.000000, -96.000000)" fill-rule="nonzero">
                                        <g id="zoom_out_line" transform="translate(864.000000, 96.000000)">
                                            <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path>
                                            <path d="M10.5,2 C15.1944,2 19,5.80558 19,10.5 C19,12.4869 18.3183,14.3145 17.176,15.7618 L20.8284,19.4142 C21.2189,19.8047 21.2189,20.4379 20.8284,20.8284 C20.4379,21.2189 19.8047,21.2189 19.4142,20.8284 L15.7618,17.176 C14.3145,18.3183 12.4869,19 10.5,19 C5.80558,19 2,15.1944 2,10.5 C2,5.80558 5.80558,2 10.5,2 Z M10.5,4 C6.91015,4 4,6.91015 4,10.5 C4,14.0899 6.91015,17 10.5,17 C14.0899,17 17,14.0899 17,10.5 C17,6.91015 14.0899,4 10.5,4 Z M14,9.5 C14.5523,9.5 15,9.94772 15,10.5 C15,11.0523 14.5523,11.5 14,11.5 L7,11.5 C6.44772,11.5 6,11.0523 6,10.5 C6,9.94772 6.44772,9.5 7,9.5 L14,9.5 Z" id="形状" fill="#fff"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </button>
                        <button class="btn btn-sm rotationButtons" type="button" @click="zoomIn()">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="File" transform="translate(-816.000000, -96.000000)" fill-rule="nonzero">
                                <g id="zoom_in_line" transform="translate(816.000000, 96.000000)">
                                <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path>
                                <path d="M10.5,2 C15.1944,2 19,5.80558 19,10.5 C19,12.3700235 18.3961412,14.098937 17.372756,15.5024913 L17.176,15.7618 L20.8284,19.4142 C21.2189,19.8047 21.2189,20.4379 20.8284,20.8284 C20.4679385,21.1888615 19.9006793,21.2165893 19.5084027,20.9115834 L19.4142,20.8284 L15.7618,17.176 C14.3145,18.3183 12.4869,19 10.5,19 C5.80558,19 2,15.1944 2,10.5 C2,5.80558 5.80558,2 10.5,2 Z M10.5,4 C6.91015,4 4,6.91015 4,10.5 C4,14.0899 6.91015,17 10.5,17 C14.0899,17 17,14.0899 17,10.5 C17,6.91015 14.0899,4 10.5,4 Z M10.5,6 C11.01285,6 11.4355092,6.38604429 11.4932725,6.88337975 L11.5,7 L11.5,9.5 L14,9.5 C14.5523,9.5 15,9.94772 15,10.5 C15,11.01285 14.613973,11.4355092 14.1166239,11.4932725 L14,11.5 L11.5,11.5 L11.5,14 C11.5,14.5523 11.0523,15 10.5,15 C9.98716857,15 9.56449347,14.613973 9.5067278,14.1166239 L9.5,14 L9.5,11.5 L7,11.5 C6.44772,11.5 6,11.0523 6,10.5 C6,9.98716857 6.38604429,9.56449347 6.88337975,9.5067278 L7,9.5 L9.5,9.5 L9.5,7 C9.5,6.44772 9.94772,6 10.5,6 Z" id="形状" fill="#fff"></path>
                                </g>
                                </g>
                                </g>
                            </svg>
                        </button>
                        <button class="btn btn-sm rotationButtons text-white" type="button" v-if="currentScale != 1  || rotationAngle != 0" @click="reset()">Sıfırla</button>
                    </div>

                </template>
            </div>
        </div>
        <div v-show="!isLoading" class="pdf-viewer-container zoomable">
            <vue-pdf-embed ref="pdfComp" @progress="loadingProgess" :rotation="rotationAngle" :annotationLayer="true"
            :textLayer="true" :source="pdfUrl" :page="page" @rendered="handleDocumentRender" :width="calculateWidth()" />
        </div>

       

    </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'

export default {
    props: {
        pdfUrl: null
    },
    components: {
        VuePdfEmbed,
    },
    data() {
        return {
            isLoading: true,
            page: null,
            pageCount: 1,
            showAllPages: true,
            progress: 0,
            loadingProgress: true,
            rotationAngle: 0,
            currentScale: 1, // Initial scale
            scaleIncrement: 0.2, // Amount to increment/decrement scale
        }
    },
    created() {
        this.calculateWidth()
    },
    watch: {
        showAllPages() {
            this.page = this.showAllPages ? null : 1
        },
    },
    methods: {
        rotate(direction) {
            // direction 1 means 90 degrees to right
            // direction 0 means 90 degrees to left
            if (direction == 1) {
                this.rotationAngle += 90
            } else {
                this.rotationAngle -= 90
            }
        },
        zoomIn() {
            this.currentScale += this.scaleIncrement;
            this.updateScale();
        },
        zoomOut() {
            if (this.currentScale > this.scaleIncrement) {
                this.currentScale -= this.scaleIncrement;
                this.updateScale();
            }
        },
        reset(){
            this.rotationAngle = 0
            this.currentScale = 1;
            this.updateScale()
        },
        updateScale() {
            const pdfViewer = document.querySelector('.pdf-viewer-container');
            pdfViewer.style.transform = `scale(${this.currentScale})`;
        },
        calculateWidth() {
            var width = screen.width * 0.4
            if(screen.width < 500){
                width = screen.width - 50
            }else if(screen.width > 500 && screen.width <= 1024){
                width = screen.width * 0.8
            }
            return width;
        },
        handleDocumentRender() {
            this.isLoading = false
            this.pageCount = this.$refs.pdfComp.pageCount
        },
        loadingProgess(e) {
            this.progress = ((e.loaded * 100) / e.total).toFixed(0)
            if (this.progress == 100) {
                this.loadingProgress = false;
            }
            if (this.loadingProgress != false) {
                let scrollProgress = document.getElementById("progress");
                scrollProgress.style.background = `conic-gradient(#0571ff ${this.progress}%, #d7d7d7 ${this.progress}%)`;
            }

        },
    }
}
</script>

<style>
.pdf-viewer-container {
  width: 100%;
  height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pdf-viewer-container > div {
  position: absolute;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  top: 0;
  left: 0;
}

.zoomable {
  transform-origin: 0 0;
  transition: transform 0.5s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pdf-controller {
    position: fixed;
    z-index: 2;
    bottom: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
}

.pdf-controller-inner {
    display: flex;
    padding: 16px;
    padding-left: 30px;
    padding-right: 30px;
    justify-content: center;
    align-items: center;
    gap: 20px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.216);
    background-color: #323232;
    color: #ddd;
    border-radius: 165px;
    transition: all 0.2s ease-in-out;
}
@media screen and (max-width: 500px) {
    .pdf-controller-inner{
        flex-direction: column;
        gap: 4px;
        border-radius: 5px;
        padding: 8px;
        padding-left: 10px;
        padding-right: 10px;
    }
}
.pdf-controller-inner label {
    margin: 0;
}

.vue-pdf-embed>div {
    margin-bottom: 14px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.pdf-container-outer {
    display: flex;
    justify-content: center;
}

.progressBar {
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    height: 6rem;
    width: 6rem;
    cursor: pointer;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

#progress {
    transition: opacity 0.2s ease-in-out;
    opacity: 1;
}

#progress-value {
    height: calc(100% - 8px);
    width: calc(100% - 8px);
    display: block;
    background-color: rgb(255, 255, 255);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

}

.loadingContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 200px;
    align-items: center;
}

.navigationButtons {
    border: 1px solid transparent;
    background-color: rgba(36, 36, 36, 0.06);
    transition: 0.2s all ease-in-out;
}
.navigationButtons:hover {
    background-color: #3b3b3b;
}
.rotationButtons {
    border: 1px solid transparent;
    transition: 0.2s all ease-in-out;
}

.rotationButtons:hover {
    background-color: #3b3b3b;
}

</style>
